import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as i } from "../../../utils/rg-util/index3.js";
import { isServiceTechSpace as m } from "../../queries/index7.js";
import { getPerimeter as o } from "../index8.js";
const l = (e, r) => o(i(e, t.TechnicalSpace, r).filter(m));
export {
  l as getLevelServicesPerimeter
};
//# sourceMappingURL=index31.js.map
